import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(9.000000, -5.000000)">
        <path
          d="M29.0739 74H23.5341L39.5568 30.3636H45.0114L61.0341 74H55.4943L42.4545 37.267H42.1136L29.0739 74ZM31.1193 56.9545H53.4489V61.642H31.1193V56.9545Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
